import React, { Fragment } from 'react'
import { lodash } from 'lodash'
import { Layout, Page, Icon, Header, Spacer, Button, Dropdown, Dialog, Loader } from 'sg-styleguide';

import EscapeWrapper from '../helpers/escape-wrapper';
import WizardLogo from '../logo';
import './iframe.scss';
class Iframe extends React.Component{

	constructor( props ) {
		super(props);

		this.themes = this.prepareThemes( this.props.themes )
	}

	prepareThemes( themes ) {
		return _.transform( themes, (result, theme) => {
			result.push( {
				value: theme.id,
				theme: theme.name,
				url: theme.live_demo_url
			} )
		},[])
	}

	changeTheme(e) {
		this.props.loading();
		this.props.previewTheme( e );
	}

	render() {
		return (
			<Dialog
				className="iframe-full-width"
				size="x-large"
				density="none"
			>
				{ ! this.props.isLoaded &&
					<Loader theme="dark">
						Loading...
					</Loader>
				}

				<Layout>
					<Page>
						<Header>
							<WizardLogo />

							<Spacer />
							{this.props.isPhone === false &&  <Dropdown
								theme="dark"
								placeholder={window.wizardData.strings.select_theme}
								options= {this.themes}
								onChange={e => this.changeTheme( e )}
								optionValue="value"
								optionLabel="theme"
								enableShadow
								selectedValue={this.props.previewedTheme.id}
								style={{minWidth: '200px'}}
							/>}
							<Spacer />

							{
								this.props.previewedTheme.id !== this.props.selectedTheme &&
								<Button
									color="primary"
									size="large"
									onClick={e => this.props.onGet()}
								>
									{this.props.isPhone? [<Icon name="check" />] : [window.wizardData.strings.select]}
								</Button>
							}

							{
								this.props.previewedTheme.id === this.props.selectedTheme &&
								<Button
									color="primary"
									size="large"
									onClick={e => this.props.changeStepNext()}
								>
									{this.props.isPhone? [<Icon name="check" />] : [window.wizardData.strings.continue]}
								</Button>
							}

							<Button
								color="neutral"
								size="large"
								onClick={e => this.props.onClose()}
							>
								<Icon name="cross" />
							</Button>
						</Header>

						<iframe
							onLoad={this.props.loaded}
							src={this.props.previewedTheme.live_demo_url}
							height="100%"
							width="100%"
						/> 

					</Page>
				</Layout>
			</Dialog>
		);
	}
}

export default EscapeWrapper( Iframe );
